// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iu0H","title":"styles_title__1E27F"};